<!--<template>-->
  <!--<div>-->
    <!--<a-card v-if="queryList" :bordered="false">-->
      <!--<div class="table-page-search-wrapper">-->
        <!--<a-form :form="form" :class="!editEnable ? 'readyOnly':''">-->
          <!--<a-row>-->
            <!--<a-col :span="24" style="display: flex;justify-content: center;">-->
              <!--<a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol" style="  margin-top: 20px;">-->
                <!--<a-upload-->
                  <!--:action="uploadUrlb"-->
                  <!--listType="picture-card"-->
                  <!--:fileList="fileList"-->
                  <!--:headers="headers"-->
                  <!--@preview="handlePreview"-->
                  <!--@change="handleChange"-->
                <!--&gt;-->
                  <!--<div v-if="fileList.length < 1">-->
                    <!--<a-icon type="plus"/>-->
                    <!--<div class="ant-upload-text">上传图片</div>-->
                  <!--</div>-->
                <!--</a-upload>-->
                <!--<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">-->
                  <!--<img alt="example" style="width: 100%" :src="previewImage"/>-->
                <!--</a-modal>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
          <!--</a-row>-->
          <!--<a-row>-->
            <!--<a-col :span="24" style="display: flex;justify-content: center;">-->
              <!--<div>-->
                <!--<a-button type="primary" style=" margin-right: 8px" @click="saved">保存</a-button>-->
                <!--<a-button @click="cancelld">取消</a-button>-->
              <!--</div>-->
            <!--</a-col>-->
          <!--</a-row>-->
        <!--</a-form>-->
      <!--</div>-->
    <!--</a-card>-->
    <!--<no-authority v-else></no-authority>-->
  <!--</div>-->
<!--</template>-->

<!--<script>-->
  <!--import { pricesUpload,getList,deleteHelpPic } from '@/api/basicdatas/Customerordersetting'-->
  <!--import {ACCESS_TOKEN} from '@/store/mutation-types'-->
  <!--import NoAuthority from '../enterprise/NoAuthority'-->
  <!--import { checkPermission } from '@/utils/permissions'-->
  <!--// import qs from 'Qs'-->

  <!--export default {-->
    <!--name: 'Customerordersetting',-->
    <!--data() {-->
      <!--return {-->
        <!--labelCol: {-->
          <!--xs: {span: 24},-->
          <!--sm: {span: 5}-->
        <!--},-->
        <!--wrapperCol: {-->
          <!--xs: {span: 24},-->
          <!--sm: {span: 16}-->
        <!--},-->
        <!--form: this.$form.createForm(this),-->
        <!--// 上传1-->
        <!--headers: {-->
          <!--token: Vue.ls.get(ACCESS_TOKEN)-->
        <!--},-->
        <!--uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=basicdatas',-->
        <!--fileList: [],-->
        <!--previewVisible: false,-->
        <!--list: {imageUrl: ""},-->
        <!--urlList:'',-->
        <!--previewImage:'',-->
        <!--queryList: checkPermission('basicdata:customerordersetting:query'),-->
        <!--editEnable: checkPermission('basicdata:customerordersetting:edit'),-->

      <!--}-->
    <!--},-->
    <!--components: {-->
      <!--NoAuthority-->
    <!--},-->
    <!--created(){-->
      <!--getList().then(res=>{-->
        <!--this.fileList = []-->
        <!--// console.log(res.picAddress)-->
        <!--let that = this-->
        <!--this.getImgToBase64(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + res.picAddress + '&token=' + Vue.ls.get(ACCESS_TOKEN),function(data){-->
          <!--that.fileList.push({-->
            <!--uid:'',-->
            <!--name:'',-->
            <!--url:res.picAddress,-->
            <!--thumbUrl:data,-->
          <!--})-->
        <!--});-->
        <!--this.urlList = res.picAddress-->
      <!--})-->
    <!--},-->
    <!--methods: {-->
      <!--// 上传-->
      <!--handleCancel() {-->
        <!--this.previewVisible = false;-->
      <!--},-->
      <!--handlePreview(file) {-->
        <!--console.log(file)-->
        <!--if(file.response){-->
          <!--this.previewImage = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.response.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)-->
        <!--}else{-->
          <!--this.previewImage = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)-->
        <!--}-->
        <!--this.previewVisible = true-->
      <!--},-->
      <!--handleChange({fileList}) {-->
        <!--console.log(fileList)-->
        <!--this.fileList = fileList;-->
        <!--this.urlList = fileList[0].response.url-->
        <!--this.list.imageUrl = fileList[0].response.fileName-->
      <!--},-->
      <!--saved(){-->
        <!--let _this = this-->
        <!--let url = this.urlList-->
        <!--let postData = this.qs.stringify({ url });-->
        <!--if (this.urlList != ''){-->
          <!--pricesUpload(postData).then(res=>{-->
            <!--console.log(res)-->
            <!--if (res.code === 0) {-->
              <!--console.log(this.fileList)-->
              <!--if(this.fileList.length == 0){-->
                <!--_this.cancelld()-->
              <!--}else{-->
                <!--this.$message.success('保存成功')-->
              <!--}-->
              <!--this.urlList = ''-->
            <!--} else {-->
              <!--this.$message.error(res.msg)-->
            <!--}-->
          <!--})-->
        <!--}else{-->
          <!--this.$message.error('请先选择需要上传的图片！')-->
        <!--}-->

      <!--},-->
      <!--cancelld(){-->
        <!--this.fileList = ""-->
        <!--deleteHelpPic().then(res=>{-->
          <!--if(res.code == 0){-->
            <!--this.$message.success('删除成功')-->
          <!--}-->
        <!--})-->
      <!--},-->
      <!--//将图片转换为Base64-->
      <!--getImgToBase64(url,callback){-->
        <!--var canvas = document.createElement('canvas'),-->
          <!--ctx = canvas.getContext('2d'),-->
          <!--img = new Image;-->
        <!--img.crossOrigin = 'Anonymous';-->
        <!--img.onload = function(){-->
          <!--canvas.height = img.height;-->
          <!--canvas.width = img.width;-->
          <!--ctx.drawImage(img,0,0);-->
          <!--var dataURL = canvas.toDataURL('image/png');-->
          <!--callback(dataURL);-->
          <!--canvas = null;-->
        <!--};-->
        <!--img.src = url;-->
      <!--},-->
    <!--}-->
  <!--}-->
<!--</script>-->

<!--<style scoped>-->
  <!--/deep/ .ant-form-item-label label:after {-->
    <!--display: none;-->
  <!--}-->
  <!--/deep/ .ant-table th { white-space: nowrap; }-->
  <!--/deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}-->
  <!--.readyOnly{-->
    <!--pointer-events: none;-->
  <!--}-->
<!--</style>-->
<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper" style="display: flex;justify-content: center">
        <a-form :form="form" style="width:50%;text-align: center">
          <a-form-item label="客服电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input  v-decorator="['stuffPhone']"/>
          </a-form-item>
          <a-form-item label="弹框提示内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea v-decorator="['remindText']"/>
          </a-form-item>
          <a-form-item label="跳转页面" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['shortLink']"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
            <a-select
              mode="multiple"

              v-decorator="['installType']"
              @change="handChange1"
            >
              <a-select-option v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              mode="multiple"

              v-decorator="['orderType']"
              @change="handChange2"
            >
              <a-select-option  v-for="type in data2" :key="type.typeCode">{{type.typeName}}</a-select-option>
            </a-select>
          </a-form-item>

          <!--<a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
            <!--<a-input v-model="queryParam.templateName"/>-->
          <!--</a-form-item>-->
          <!--<a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
            <!--<a-input v-model="queryParam.templateName"/>-->
          <!--</a-form-item>-->
          <div>
            <a-button type="primary" @click="saved">保存</a-button>
            <!--<a-button @click="cancelld">取消</a-button>-->
          </div>
        </a-form>
      </div>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
  // import { STable } from '@/components'
  import { getOrderType,saveClientConfig,selectClientOrderConfig } from '@/api/basicdatas/Customerordersetting'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import pick from 'lodash.pick'
  import ATextarea from "ant-design-vue/es/input/TextArea";

  export default {
    name: 'TableList',
    components: {
      ATextarea

    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          templateName:'4008701162',
        },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return getDistrictTemplate(Object.assign(parameter, this.queryParam))
        },
        data2:[],
        restaurantTypes:[],
        queryList: checkPermission('basicdata:customerordersetting:query'),
        editEnable: checkPermission('basicdata:customerordersetting:edit'),
      }
    },
    filters: {
    },
    async created () {
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
      selectClientOrderConfig().then(res=>{
        // console.log(res.installType)
        if(res.installType != "" && res.installType != undefined){
          let arr = []
          arr = res.installType.split(';')
          res.installType = arr
          this.handChange1(res.installType)
        }else{
          res.installType = undefined
        }
        if(res.orderType != "" && res.orderType != undefined){
          let arr1 = []
          arr1 = res.orderType.split(';')
          res.orderType = arr1
        }else{
          res.orderType = undefined
        }
        this.form.setFieldsValue(pick(res, 'stuffPhone', 'remindText', 'shortLink', 'installType', 'orderType'))
      })
    },
    methods: {
      handChange1(value){
        console.log(`selected ${value}`);
        this.form.setFieldsValue({'orderType':undefined})
        getOrderType(value).then(res => {
          console.log(res.rows)
          let rows = res.rows
          let result = []
          this.data2 = []
          for (let i = 0; i < rows.length; i++) {
            // console.log(rows[i])
            result = result.concat(rows[i]);
          }
          this.data2 = result
          // console.log(this.data2)
        })
      },
      saved(e){
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            this.confirmLoading = true
            values.installType = values.installType.join(';')
            console.log(values.orderType)
            if(values.orderType != undefined){
              values.orderType = values.orderType.join(';')
            }
            saveClientConfig(values).then(res => {
              if (res.code === 0) {
                if(res.data != '订单类型重复'){
                  this.$message.success('保存成功')
                }else{
                  this.$message.error(res.data)
                }
              }
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        })
      },
    },
    watch: {
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px;}
  /deep/ .ant-table-content{
    width:25%
  }
</style>